const intercomAppId = process.env.INTERCOM_APP_ID || 'dft0l0px';

const intercomSettings = {
  api_base: 'https://api-iam.intercom.io',
  app_id: intercomAppId,
  hide_default_launcher: false,
};

(function () {
  var w = window;
  var ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var l = function () {
      var s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/' + intercomAppId;
      var x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };
    if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
})();

class Intercom {
  shutdown() {
    window.Intercom && window.Intercom('shutdown');
    // console.log('window.Intercom logout');
  }

  setup(user) {
    let params = {
      app_id: intercomAppId,
      'User Type': 'POS Visitor',
    };
    if (user) {
      const { id, email, created_at, first_name, last_name, hmac_digest } = user;
      params = {
        ...params,
        user_id: id,
        name: [first_name, last_name].join(' '),
        email,
        user_hash: hmac_digest,
        created_at,
        'Profile Page': `https://api.chowbus.com/backend/users/${id}`,
      };
    }
    window.Intercom && window.Intercom('boot', params);
  }
}
export const intercom = new Intercom();
